type CountryFlagCode = {
  name: string;
  flagCode: string;
  countryCode: string;
};

const countries: CountryFlagCode[] = [
  { name: 'Afghanistan', flagCode: 'af', countryCode: 'AFG' },
  { name: 'Aland Islands', flagCode: 'ax', countryCode: 'ALA' },
  { name: 'Albania', flagCode: 'al', countryCode: 'ALB' },
  { name: 'Algeria', flagCode: 'dz', countryCode: 'DZA' },
  { name: 'American Samoa', flagCode: 'as', countryCode: 'ASM' },
  { name: 'Andorra', flagCode: 'ad', countryCode: 'AND' },
  { name: 'Angola', flagCode: 'ao', countryCode: 'AGO' },
  { name: 'Anguilla', flagCode: 'ai', countryCode: 'AIA' },
  { name: 'Antigua', flagCode: 'ag', countryCode: 'ATG' },
  { name: 'Argentina', flagCode: 'ar', countryCode: 'ARG' },
  { name: 'Armenia', flagCode: 'am', countryCode: 'ARM' },
  { name: 'Aruba', flagCode: 'aw', countryCode: 'ABW' },
  { name: 'Australia', flagCode: 'au', countryCode: 'AUS' },
  { name: 'Austria', flagCode: 'at', countryCode: 'AUT' },
  { name: 'Azerbaijan', flagCode: 'az', countryCode: 'AZE' },
  { name: 'Bahamas', flagCode: 'bs', countryCode: 'BHS' },
  { name: 'Bahrain', flagCode: 'bh', countryCode: 'BHR' },
  { name: 'Bangladesh', flagCode: 'bd', countryCode: 'BGD' },
  { name: 'Barbados', flagCode: 'bb', countryCode: 'BRB' },
  { name: 'Belarus', flagCode: 'by', countryCode: 'BLR' },
  { name: 'Belgium', flagCode: 'be', countryCode: 'BEL' },
  { name: 'Belize', flagCode: 'bz', countryCode: 'BLZ' },
  { name: 'Benin', flagCode: 'bj', countryCode: 'BEN' },
  { name: 'Bermuda', flagCode: 'bm', countryCode: 'BMU' },
  { name: 'Bhutan', flagCode: 'bt', countryCode: 'BTN' },
  { name: 'Bolivia', flagCode: 'bo', countryCode: 'BOL' },
  { name: 'Bosnia', flagCode: 'ba', countryCode: 'BIH' },
  { name: 'Botswana', flagCode: 'bw', countryCode: 'BWA' },
  { name: 'Bouvet Island', flagCode: 'bv', countryCode: 'BVT' },
  { name: 'Brazil', flagCode: 'br', countryCode: 'BRA' },
  { name: 'British Virgin Islands', flagCode: 'vg', countryCode: 'VGB' },
  { name: 'Brunei', flagCode: 'bn', countryCode: 'BRN' },
  { name: 'Bulgaria', flagCode: 'bg', countryCode: 'BGR' },
  { name: 'Burkina Faso', flagCode: 'bf', countryCode: 'BFA' },
  { name: 'Burma', flagCode: 'mm', countryCode: 'MMR' },
  { name: 'Burundi', flagCode: 'bi', countryCode: 'BDI' },
  { name: 'Caicos Islands', flagCode: 'tc', countryCode: 'TCA' },
  { name: 'Cambodia', flagCode: 'kh', countryCode: 'KHM' },
  { name: 'Cameroon', flagCode: 'cm', countryCode: 'CMR' },
  { name: 'Canada', flagCode: 'ca', countryCode: 'CAN' },
  { name: 'Cape Verde', flagCode: 'cv', countryCode: 'CPV' },
  { name: 'Cayman Islands', flagCode: 'ky', countryCode: 'CYM' },
  { name: 'Central African Republic', flagCode: 'cf', countryCode: 'CAF' },
  { name: 'Chad', flagCode: 'td', countryCode: 'TCD' },
  { name: 'Chile', flagCode: 'cl', countryCode: 'CHL' },
  { name: 'China', flagCode: 'cn', countryCode: 'CHN' },
  { name: 'Christmas Island', flagCode: 'cx', countryCode: 'CXR' },
  { name: 'Cocos Islands', flagCode: 'cc', countryCode: 'CCK' },
  { name: 'Colombia', flagCode: 'co', countryCode: 'COL' },
  { name: 'Comoros', flagCode: 'km', countryCode: 'COM' },
  { name: 'Congo', flagCode: 'cd', countryCode: 'COD' },
  { name: 'Congo Brazzaville', flagCode: 'cg', countryCode: 'COG' },
  { name: 'Cook Islands', flagCode: 'ck', countryCode: 'COK' },
  { name: 'Costa Rica', flagCode: 'cr', countryCode: 'CRI' },
  { name: 'Cote Divoire', flagCode: 'ci', countryCode: 'CIV' },
  { name: 'Croatia', flagCode: 'hr', countryCode: 'HRV' },
  { name: 'Cuba', flagCode: 'cu', countryCode: 'CUB' },
  { name: 'Cyprus', flagCode: 'cy', countryCode: 'CYP' },
  { name: 'Czech Republic', flagCode: 'cz', countryCode: 'CZE' },
  { name: 'Denmark', flagCode: 'dk', countryCode: 'DNK' },
  { name: 'Djibouti', flagCode: 'dj', countryCode: 'DJI' },
  { name: 'Dominica', flagCode: 'dm', countryCode: 'DMA' },
  { name: 'Dominican Republic', flagCode: 'do', countryCode: 'DOM' },
  { name: 'Ecuador', flagCode: 'ec', countryCode: 'ECU' },
  { name: 'Egypt', flagCode: 'eg', countryCode: 'EGY' },
  { name: 'El Salvador', flagCode: 'sv', countryCode: 'SLV' },
  { name: 'England', flagCode: 'gb eng', countryCode: 'ENG' },
  { name: 'Equatorial Guinea', flagCode: 'gq', countryCode: 'GNQ' },
  { name: 'Eritrea', flagCode: 'er', countryCode: 'ERI' },
  { name: 'Estonia', flagCode: 'ee', countryCode: 'EST' },
  { name: 'Ethiopia', flagCode: 'et', countryCode: 'ETH' },
  { name: 'Europeanunion', flagCode: 'eu', countryCode: 'EU' },
  { name: 'Falkland Islands', flagCode: 'fk', countryCode: 'FLK' },
  { name: 'Faroe Islands', flagCode: 'fo', countryCode: 'FRO' },
  { name: 'Fiji', flagCode: 'fj', countryCode: 'FJI' },
  { name: 'Finland', flagCode: 'fi', countryCode: 'FIN' },
  { name: 'France', flagCode: 'fr', countryCode: 'FRA' },
  { name: 'French Guiana', flagCode: 'gf', countryCode: 'GUF' },
  { name: 'French Polynesia', flagCode: 'pf', countryCode: 'PYF' },
  { name: 'French Territories', flagCode: 'tf', countryCode: 'ATF' },
  { name: 'Gabon', flagCode: 'ga', countryCode: 'GAB' },
  { name: 'Gambia', flagCode: 'gm', countryCode: 'GMB' },
  { name: 'Georgia', flagCode: 'ge', countryCode: 'GEO' },
  { name: 'Germany', flagCode: 'de', countryCode: 'DEU' },
  { name: 'Ghana', flagCode: 'gh', countryCode: 'GHA' },
  { name: 'Gibraltar', flagCode: 'gi', countryCode: 'GIB' },
  { name: 'Greece', flagCode: 'gr', countryCode: 'GRC' },
  { name: 'Greenland', flagCode: 'gl', countryCode: 'GRL' },
  { name: 'Grenada', flagCode: 'gd', countryCode: 'GRD' },
  { name: 'Guadeloupe', flagCode: 'gp', countryCode: 'GLP' },
  { name: 'Guam', flagCode: 'gu', countryCode: 'GUM' },
  { name: 'Guatemala', flagCode: 'gt', countryCode: 'GTM' },
  { name: 'Guinea', flagCode: 'gn', countryCode: 'GIN' },
  { name: 'Guinea-Bissau', flagCode: 'gw', countryCode: 'GNB' },
  { name: 'Guyana', flagCode: 'gy', countryCode: 'GUY' },
  { name: 'Haiti', flagCode: 'ht', countryCode: 'HTI' },
  { name: 'Heard Island', flagCode: 'hm', countryCode: 'HMD' },
  { name: 'Honduras', flagCode: 'hn', countryCode: 'HND' },
  { name: 'Hong Kong', flagCode: 'hk', countryCode: 'HKG' },
  { name: 'Hungary', flagCode: 'hu', countryCode: 'HUN' },
  { name: 'Iceland', flagCode: 'is', countryCode: 'ISL' },
  { name: 'India', flagCode: 'in', countryCode: 'IND' },
  { name: 'Indian Ocean Territory', flagCode: 'io', countryCode: 'IOT' },
  { name: 'Indonesia', flagCode: 'id', countryCode: 'IDN' },
  { name: 'Iran', flagCode: 'ir', countryCode: 'IRN' },
  { name: 'Iraq', flagCode: 'iq', countryCode: 'IRQ' },
  { name: 'Ireland', flagCode: 'ie', countryCode: 'IRL' },
  { name: 'Israel', flagCode: 'il', countryCode: 'ISR' },
  { name: 'Italy', flagCode: 'it', countryCode: 'ITA' },
  { name: 'Jamaica', flagCode: 'jm', countryCode: 'JAM' },
  { name: 'Jan Mayen', flagCode: 'sj', countryCode: 'SJM' },
  { name: 'Japan', flagCode: 'jp', countryCode: 'JPN' },
  { name: 'Jordan', flagCode: 'jo', countryCode: 'JOR' },
  { name: 'Kazakhstan', flagCode: 'kz', countryCode: 'KAZ' },
  { name: 'Kenya', flagCode: 'ke', countryCode: 'KEN' },
  { name: 'Kiribati', flagCode: 'ki', countryCode: 'KIR' },
  { name: 'Kuwait', flagCode: 'kw', countryCode: 'KWT' },
  { name: 'Kyrgyzstan', flagCode: 'kg', countryCode: 'KGZ' },
  { name: 'Laos', flagCode: 'la', countryCode: 'LAO' },
  { name: 'Latvia', flagCode: 'lv', countryCode: 'LVA' },
  { name: 'Lebanon', flagCode: 'lb', countryCode: 'LBN' },
  { name: 'Lesotho', flagCode: 'ls', countryCode: 'LSO' },
  { name: 'Liberia', flagCode: 'lr', countryCode: 'LBR' },
  { name: 'Libya', flagCode: 'ly', countryCode: 'LBY' },
  { name: 'Liechtenstein', flagCode: 'li', countryCode: 'LIE' },
  { name: 'Lithuania', flagCode: 'lt', countryCode: 'LTU' },
  { name: 'Luxembourg', flagCode: 'lu', countryCode: 'LUX' },
  { name: 'Macau', flagCode: 'mo', countryCode: 'MAC' },
  { name: 'Macedonia', flagCode: 'mk', countryCode: 'MKD' },
  { name: 'Madagascar', flagCode: 'mg', countryCode: 'MDG' },
  { name: 'Malawi', flagCode: 'mw', countryCode: 'MWI' },
  { name: 'Malaysia', flagCode: 'my', countryCode: 'MYS' },
  { name: 'Maldives', flagCode: 'mv', countryCode: 'MDV' },
  { name: 'Mali', flagCode: 'ml', countryCode: 'MLI' },
  { name: 'Malta', flagCode: 'mt', countryCode: 'MLT' },
  { name: 'Marshall Islands', flagCode: 'mh', countryCode: 'MHL' },
  { name: 'Martinique', flagCode: 'mq', countryCode: 'MTQ' },
  { name: 'Mauritania', flagCode: 'mr', countryCode: 'MRT' },
  { name: 'Mauritius', flagCode: 'mu', countryCode: 'MUS' },
  { name: 'Mayotte', flagCode: 'yt', countryCode: 'MYT' },
  { name: 'Mexico', flagCode: 'mx', countryCode: 'MEX' },
  { name: 'Micronesia', flagCode: 'fm', countryCode: 'FSM' },
  { name: 'Moldova', flagCode: 'md', countryCode: 'MDA' },
  { name: 'Monaco', flagCode: 'mc', countryCode: 'MCO' },
  { name: 'Mongolia', flagCode: 'mn', countryCode: 'MNG' },
  { name: 'Montenegro', flagCode: 'me', countryCode: 'MNE' },
  { name: 'Montserrat', flagCode: 'ms', countryCode: 'MSR' },
  { name: 'Morocco', flagCode: 'ma', countryCode: 'MAR' },
  { name: 'Mozambique', flagCode: 'mz', countryCode: 'MOZ' },
  { name: 'Namibia', flagCode: 'na', countryCode: 'NAM' },
  { name: 'Nauru', flagCode: 'nr', countryCode: 'NRU' },
  { name: 'Nepal', flagCode: 'np', countryCode: 'NPL' },
  { name: 'Netherlands', flagCode: 'nl', countryCode: 'NLD' },
  { name: 'Netherlands Antilles', flagCode: 'an', countryCode: 'ANT' },
  { name: 'New Caledonia', flagCode: 'nc', countryCode: 'NCL' },
  { name: 'New Guinea', flagCode: 'pg', countryCode: 'PNG' },
  { name: 'New Zealand', flagCode: 'nz', countryCode: 'NZL' },
  { name: 'Nicaragua', flagCode: 'ni', countryCode: 'NIC' },
  { name: 'Niger', flagCode: 'ne', countryCode: 'NER' },
  { name: 'Nigeria', flagCode: 'ng', countryCode: 'NGA' },
  { name: 'Niue', flagCode: 'nu', countryCode: 'NIU' },
  { name: 'Norfolk Island', flagCode: 'nf', countryCode: 'NFK' },
  { name: 'North Korea', flagCode: 'kp', countryCode: 'PRK' },
  { name: 'Northern Mariana Islands', flagCode: 'mp', countryCode: 'MNP' },
  { name: 'Norway', flagCode: 'no', countryCode: 'NOR' },
  { name: 'Oman', flagCode: 'om', countryCode: 'OMN' },
  { name: 'Pakistan', flagCode: 'pk', countryCode: 'PAK' },
  { name: 'Palau', flagCode: 'pw', countryCode: 'PLW' },
  { name: 'Palestine', flagCode: 'ps', countryCode: 'PSE' },
  { name: 'Panama', flagCode: 'pa', countryCode: 'PAN' },
  { name: 'Paraguay', flagCode: 'py', countryCode: 'PRY' },
  { name: 'Peru', flagCode: 'pe', countryCode: 'PER' },
  { name: 'Philippines', flagCode: 'ph', countryCode: 'PHL' },
  { name: 'Pitcairn Islands', flagCode: 'pn', countryCode: 'PCN' },
  { name: 'Poland', flagCode: 'pl', countryCode: 'POL' },
  { name: 'Portugal', flagCode: 'pt', countryCode: 'PRT' },
  { name: 'Puerto Rico', flagCode: 'pr', countryCode: 'PRI' },
  { name: 'Qatar', flagCode: 'qa', countryCode: 'QAT' },
  { name: 'Reunion', flagCode: 're', countryCode: 'REU' },
  { name: 'Romania', flagCode: 'ro', countryCode: 'ROU' },
  { name: 'Russia', flagCode: 'ru', countryCode: 'RUS' },
  { name: 'Rwanda', flagCode: 'rw', countryCode: 'RWA' },
  { name: 'Saint Helena', flagCode: 'sh', countryCode: 'SHN' },
  { name: 'Saint Kitts and Nevis', flagCode: 'kn', countryCode: 'KNA' },
  { name: 'Saint Lucia', flagCode: 'lc', countryCode: 'LCA' },
  { name: 'Saint Pierre', flagCode: 'pm', countryCode: 'SPM' },
  { name: 'Saint Vincent', flagCode: 'vc', countryCode: 'VCT' },
  { name: 'Samoa', flagCode: 'ws', countryCode: 'WSM' },
  { name: 'San Marino', flagCode: 'sm', countryCode: 'SMR' },
  { name: 'Sandwich Islands', flagCode: 'gs', countryCode: 'SGS' },
  { name: 'Sao Tome', flagCode: 'st', countryCode: 'STP' },
  { name: 'Saudi Arabia', flagCode: 'sa', countryCode: 'SAU' },
  { name: 'Scotland', flagCode: 'gb sct', countryCode: 'SCT' },
  { name: 'Senegal', flagCode: 'sn', countryCode: 'SEN' },
  { name: 'Serbia', flagCode: 'rs', countryCode: 'SRB' },
  { name: 'Seychelles', flagCode: 'sc', countryCode: 'SYC' },
  { name: 'Sierra Leone', flagCode: 'sl', countryCode: 'SLE' },
  { name: 'Singapore', flagCode: 'sg', countryCode: 'SGP' },
  { name: 'Slovakia', flagCode: 'sk', countryCode: 'SVK' },
  { name: 'Slovenia', flagCode: 'si', countryCode: 'SVN' },
  { name: 'Solomon Islands', flagCode: 'sb', countryCode: 'SLB' },
  { name: 'Somalia', flagCode: 'so', countryCode: 'SOM' },
  { name: 'South Africa', flagCode: 'za', countryCode: 'ZAF' },
  { name: 'South Korea', flagCode: 'kr', countryCode: 'KOR' },
  { name: 'Spain', flagCode: 'es', countryCode: 'ESP' },
  { name: 'Sri Lanka', flagCode: 'lk', countryCode: 'LKA' },
  { name: 'Sudan', flagCode: 'sd', countryCode: 'SDN' },
  { name: 'Suriname', flagCode: 'sr', countryCode: 'SUR' },
  { name: 'Swaziland', flagCode: 'sz', countryCode: 'SWZ' },
  { name: 'Sweden', flagCode: 'se', countryCode: 'SWE' },
  { name: 'Switzerland', flagCode: 'ch', countryCode: 'CHE' },
  { name: 'Syria', flagCode: 'sy', countryCode: 'SYR' },
  { name: 'Taiwan', flagCode: 'tw', countryCode: 'TWN' },
  { name: 'Tajikistan', flagCode: 'tj', countryCode: 'TJK' },
  { name: 'Tanzania', flagCode: 'tz', countryCode: 'TZA' },
  { name: 'Thailand', flagCode: 'th', countryCode: 'THA' },
  { name: 'Timorleste', flagCode: 'tl', countryCode: 'TLS' },
  { name: 'Togo', flagCode: 'tg', countryCode: 'TGO' },
  { name: 'Tokelau', flagCode: 'tk', countryCode: 'TKL' },
  { name: 'Tonga', flagCode: 'to', countryCode: 'TON' },
  { name: 'Trinidad', flagCode: 'tt', countryCode: 'TTO' },
  { name: 'Tunisia', flagCode: 'tn', countryCode: 'TUN' },
  { name: 'Turkey', flagCode: 'tr', countryCode: 'TUR' },
  { name: 'Turkmenistan', flagCode: 'tm', countryCode: 'TKM' },
  { name: 'Tuvalu', flagCode: 'tv', countryCode: 'TUV' },
  { name: 'U.A.E.', flagCode: 'ae', countryCode: 'ARE' },
  { name: 'Uganda', flagCode: 'ug', countryCode: 'UGA' },
  { name: 'Ukraine', flagCode: 'ua', countryCode: 'UKR' },
  { name: 'United Kingdom', flagCode: 'gb', countryCode: 'GBR' },
  { name: 'United States', flagCode: 'us', countryCode: 'USA' },
  { name: 'Uruguay', flagCode: 'uy', countryCode: 'URY' },
  { name: 'US Minor Islands', flagCode: 'um', countryCode: 'UMI' },
  { name: 'US Virgin Islands', flagCode: 'vi', countryCode: 'VIR' },
  { name: 'Uzbekistan', flagCode: 'uz', countryCode: 'UZB' },
  { name: 'Vanuatu', flagCode: 'vu', countryCode: 'VUT' },
  { name: 'Vatican City', flagCode: 'va', countryCode: 'VAT' },
  { name: 'Venezuela', flagCode: 've', countryCode: 'VEN' },
  { name: 'Vietnam', flagCode: 'vn', countryCode: 'VNM' },
  { name: 'Wales', flagCode: 'gb wls', countryCode: 'WLS' },
  { name: 'Wallis and Futuna', flagCode: 'wf', countryCode: 'WLF' },
  { name: 'Western Sahara', flagCode: 'eh', countryCode: 'ESH' },
  { name: 'Yemen', flagCode: 'ye', countryCode: 'YEM' },
  { name: 'Zambia', flagCode: 'zm', countryCode: 'ZMB' },
  { name: 'Zimbabwe', flagCode: 'zw', countryCode: 'ZWE' },
];

export default countries;
